/**
 * The Proxies page's words.
 *
 * 🔴 It used to say «Egress routes used when talking to X, so requests leave from the
 * geography an account expects» — the plan the page came with from fbads, not what this
 * console does (3d, 30.10; audits/2026-10-30/proxies-how-it-works.md). The worker sends
 * every call to X with `fetch` straight to X's host (worker platform/x-api.ts: `xAdsBaseUrl`
 * :64–66, the URL :261, the request :288); nothing in it reads the proxy table, and
 * `wrangler.toml` binds no proxy. The rows are the kit's records, and only that.
 */
export const PROXIES_ABOUT =
	"A registry of proxies — an address, a country and a 1Password item by name. This console does not send its calls to X through them yet: they go to X directly. Credentials are never stored here — a proxy points at a 1Password item by name.";
